import { Injectable } from '@angular/core';
import { LoggingService } from '@common-services/log/logging.service';

@Injectable({
  providedIn: 'platform',
})
export class GlobalLoggingService {
  initGlobalLogger(loggingService: LoggingService): void {
    // @ts-ignore
    window.customLogger = {
      trace: loggingService.trace.bind(loggingService),
      debug: loggingService.debug.bind(loggingService),
      info: loggingService.info.bind(loggingService),
      log: loggingService.log.bind(loggingService),
      warn: loggingService.warn.bind(loggingService),
      error: loggingService.error.bind(loggingService),
      fatal: loggingService.fatal.bind(loggingService),
    };
  }
}
